<template>
  <div :style="{ height: height }" class="top">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>修改登录密码<i v-if="googleVerifyFlag">(忘记原密码,可以选择谷歌验证)</i></span>
      </div>
      <div class="text item">
        <el-form
          :model="updateForm"
          ref="updateForm"
          :rules="updateFormRules"
          size="mini"
        >
          <el-form-item
            label="验证方式"
            prop="checkType"
            :label-width="formLabelWidth"
            v-if="googleVerifyFlag"
          >
            <el-radio v-model="updateForm.checkType" label="1">原密码验证</el-radio>
            <el-radio v-model="updateForm.checkType" label="2">谷歌验证码验证</el-radio>
          </el-form-item>

          <el-form-item
            label="原密码"
            prop="oldpwd"
            :label-width="formLabelWidth"
            v-if="!googleVerifyFlag||updateForm.checkType=='1'"
          >
            <el-input
              class="width-300"
              type="password"
              maxlength="32"
              v-model="updateForm.oldpwd"
              placeholder="请输入原密码"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="谷歌验证码"
            prop="googleVerifyCode"
            :label-width="formLabelWidth"
            v-if="googleVerifyFlag&&updateForm.checkType=='2'"
          >
            <el-input
              class="width-300"
              maxlength="6"
              v-model="updateForm.googleVerifyCode"
              placeholder="请输入谷歌验证码"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="新密码"
            prop="newpwd"
            :label-width="formLabelWidth"
          >
            <el-input
              class="width-300"
              type="password"
              maxlength="32"
              v-model="updateForm.newpwd"
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="确认新密码"
            prop="checkPass"
            :label-width="formLabelWidth"
          >
            <el-input
              class="width-300"
              type="password"
              maxlength="32"
              v-model="updateForm.checkPass"
              placeholder="请确认新密码"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="handleResetSubmit('updateForm')"
            size="small"
          >确认修改</el-button>
        </div>
      </div>
    </el-card>

  </div>
</template>

<script>
import axios from 'axios'
import rsa from '@/utils/rsa'
export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.updateForm.newpwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      height: window.innerHeight - 200 + 'px',
      formLabelWidth: '100px',
      updateForm: {
        checkType: '1',
        oldpwd: '',
        googleVerifyCode: '',
        newpwd: '',
        checkPass: ''
      },
      updateFormRules: {
        oldpwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        googleVerifyCode: [{ required: true, message: '请输入谷歌验证码', trigger: 'blur' }],
        newpwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        checkPass: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ]
      },
      googleVerifyFlag: false
    }
  },
  mounted () {
    this.getGoogleFlag()
  },
  methods: {
    getGoogleFlag () {
      axios({
        url: this.baseUrl + '/googleFlag',
        method: 'get'
      }).then(res => {
        if (res.data.code === '0000') {
          this.googleVerifyFlag = res.data.data
        }
      }).catch(err => {
        console.log(err, 'loginerr')
      })
    },
    handleResetSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.changePassword()
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    changePassword () {
      axios({
        url: this.baseUrl + '/modifyPwd',
        method: 'POST',
        data: {
          checkType: this.updateForm.checkType,
          googleVerifyCode: this.updateForm.googleVerifyCode,
          oldpwd: rsa.rsaPublicData(this.updateForm.oldpwd),
          newpwd: rsa.rsaPublicData(this.updateForm.newpwd)
        }
      }).then((res) => {
        if (res.data.code === '0000') {
          this.$message.success('登录密码修改成功')
          // console.log('success', 'changePassword')
        }
      }).catch((err) => {
        console.log(err, 'changePassword')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
div.top {
  margin: 20px;
}
span.status {
  margin-right: 100px;
}
.el-dialog__header {
  border-bottom: #cccccc solid 1px;
}
.el-image-viewer__close {
  top: 80px;
}
</style>
